var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdsicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.383,
    height: 18.616,
    viewBox: "0 0 27.383 18.616",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_933",
    "data-name": "Group 933",
    transform: "translate(-28.117 -212.126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M159.1,506.148h-17.55a1.576,1.576,0,0,1,.756-1.916,10.793,10.793,0,0,1,3.146-1.164c.245-.06.492-.113.741-.149a2.208,2.208,0,0,0,1.49-.9,7.1,7.1,0,0,0,.543-.834c.276-.5.266-.5-.152-.877a8.12,8.12,0,0,1-1.822-2.688,2.845,2.845,0,0,0-.326-.517,2.6,2.6,0,0,1-.565-1.7c.013-.483.173-.682.574-.8-.036-.63-.089-1.256-.1-1.884a3.925,3.925,0,0,1,3.741-4.143,5.144,5.144,0,0,1,3.586.766,3.518,3.518,0,0,1,1.62,2.993c.019.685-.068,1.372-.106,2.059,0,.067,0,.135,0,.2a.74.74,0,0,1,.594.839,2.612,2.612,0,0,1-.588,1.688,2.324,2.324,0,0,0-.292.458,7.62,7.62,0,0,1-2.1,2.942.3.3,0,0,0-.064.279,16,16,0,0,0,1.026,1.534,2.168,2.168,0,0,0,1.245.6c1.04.27,2.065.6,3.092.913a2.723,2.723,0,0,1,.492.243A1.671,1.671,0,0,1,159.1,506.148Z",
    transform: "translate(-112.857 -275.905)",
    fill: "#4356a0",
    stroke: "#4356a0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_64",
    "data-name": "Line 64",
    x2: 6,
    transform: "translate(45.5 214.5)",
    fill: "none",
    stroke: "#4356a0",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_65",
    "data-name": "Line 65",
    x2: 9,
    transform: "translate(45.5 218.5)",
    fill: "none",
    stroke: "#4356a0",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_66",
    "data-name": "Line 66",
    x2: 7,
    transform: "translate(45.5 222.5)",
    fill: "none",
    stroke: "#4356a0",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdsicon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/ids.icon.c0b1e1ac59d085bb8e4e46d67c6150ed.svg";
export { ForwardRef as ReactComponent };